/**
 * Currently provides wizard dialogs to prompt users
 * to connect the appropriate linked account to a
 * social partner for a given listing.
 *
 * @author Jon Hyler (jonhyler@yext.com)
 */
goog.provide('yext.listings.wizard');

goog.require('yext');
goog.require('yext.dialog');
goog.require('yext.storm.routesDEPRECATED');

goog.scope(function() {
  const _listings = yext.listings.wizard;

  /**
   * Set up an event listener for LocationEdit
   */
  _listings.initFoursquareLocEdit = function() {
    $('.js-foursquare-special-setup').click(function(e) {
      // stop propagation to parent elements
      e.stopPropagation();

      // show the wizard for foursquare
      _listings.showLinkFoursquareWizard();
    });
  };

  /**
   * Initialize wizard dialogs
   * @suppress {deprecated}
   */
  _listings.initDialogs = function() {
    _listings.flwDialogs = $('.flw-dialog');
    _listings.flwFixDialog = $('.flw-fix-dialog');
    _listings.flwAssignDialog = $('.flw-assign-loc-dialog');

    _listings.flwDialogs.dialog({
      modal: true,
      draggable: false,
      resizable: false,
      autoOpen: false,
      width: 450,
    }).bind('dialogclose', function() {
      $(this).find('.toClose').hide();
    }).find('.button-cancel').click(function() {
      $(this).closest('.ui-dialog-content').dialog('close');
      return false;
    });

    _listings.flwFixDialog.find('.assign-button').click(function() {
      const partnerId = _listings.flwFixDialog.attr('data-partnerId');

      _listings.flwAssignDialog
        .find('.account-select-' + partnerId).show()
        .siblings('.account-select').hide();

      _listings.flwFixDialog.dialog('close');
      _listings.flwAssignDialog.dialog('open');
      return false;
    });

    _listings.flwAssignDialog.find('.primary').click(function() {
      return false;
    });
  };
  goog.exportSymbol('yext.listings.wizard.initDialogs', _listings.initDialogs);

  /**
   * Show the wizard for Foursquare on the LocationEdit page
   * @suppress {deprecated}
   */
  _listings.showLinkFoursquareWizard = function() {
    // Foursquare is the partner
    const brand = yext.msg('Foursquare');
    const title = yext.msg('Foursquare Listing');
    const partnerId = 440;
    const locationId = $('.js-location-info').data('location-id');

    _listings.flwDialogs.data('partnerId', partnerId);
    _listings.flwDialogs.data('locationId', locationId);

    _listings.flwDialogs.dialog('option', 'title', title);
    _listings.flwDialogs.find('.brand').text(brand);
    _listings.flwAssignDialog.find('.account-select').hide();
    _listings.flwAssignDialog.find('.account-select-' + partnerId).show();

    _listings.flwFixDialog.find('.no-linked-account').show();
    _listings.flwFixDialog.find('.link-button-' + partnerId).show();
    if (_listings.flwAssignDialog.find('input[name="available-' + partnerId + '"]').val() > 0) {
      _listings.flwFixDialog.find('.assign-button').show();
    }

    _listings.flwFixDialog.dialog('open');
    return false;
  };
});
